module.exports = __webpack_public_path__ + "img/minregion_small.27054292.png";